import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M21.2591 12.621C20.8861 12.571 20.5191 12.834 20.4641 13.219C19.9751 16.669 17.4291 19.419 14.1901 20.297C15.4901 18.466 16.6541 15.363 16.6541 11.996C16.6541 6.94105 13.9771 1.99805 11.9801 1.99805C6.4801 1.99805 2.0061 6.48305 2.0061 11.996C2.0061 17.509 6.4751 21.995 11.9711 22C11.9741 22 11.9781 22.001 11.9811 22.001C11.9841 22.001 11.9871 22 11.9901 22C16.9231 21.996 21.1651 18.307 21.8591 13.415C21.9121 13.032 21.6451 12.676 21.2601 12.621H21.2591ZM11.9731 3.40405C11.9741 3.40405 11.9741 3.40405 11.9751 3.40405C12.7271 3.48405 15.0071 6.81605 15.2291 11.293H8.8581C9.0661 6.74605 11.2371 3.49005 11.9741 3.40405H11.9731ZM9.7311 3.71405C8.5601 5.44205 7.5851 8.27705 7.4491 11.293H3.4461C3.7421 7.64905 6.3131 4.64805 9.7301 3.71405H9.7311ZM3.4461 12.699H7.4521C7.5961 15.653 8.6211 18.549 9.8131 20.305C6.3551 19.396 3.7461 16.375 3.4471 12.699H3.4461ZM11.9811 20.588C11.2931 20.331 9.0731 17.203 8.8581 12.699H15.2281C14.9991 17.137 12.6731 20.337 11.9801 20.588H11.9811Z"
      fill="currentColor"
    />
    <path
      d="M20.134 10.116C20.134 10.626 20.552 11.041 21.066 11.041C21.578 11.041 21.995 10.626 21.995 10.116C21.995 9.60099 21.578 9.18299 21.066 9.18299C20.552 9.18199 20.134 9.60099 20.134 10.116Z"
      fill="currentColor"
    />
    <path
      d="M19.847 8.00204C20.36 8.00204 20.777 7.58704 20.777 7.07704C20.777 6.56304 20.36 6.14404 19.847 6.14404C19.335 6.14404 18.918 6.56304 18.918 7.07704C18.918 7.58704 19.335 8.00204 19.847 8.00204Z"
      fill="currentColor"
    />
    <path
      d="M18.641 4.69997C18.641 5.21497 18.225 5.63297 17.712 5.63297C17.199 5.63297 16.783 5.21497 16.783 4.69997C16.783 4.18497 17.199 3.76697 17.712 3.76697C18.225 3.76697 18.641 4.18497 18.641 4.69997Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Internet');

export default Icon;
